import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from 'react';
import { showMessage } from 'app/store/fuse/messageSlice';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import jwtService from '../../auth/services/jwtService';
import { Button, Grid, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CustomTextField from 'app/shared-components/CustomTextField';
import { Link } from 'react-router-dom';

/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
  identifier: yup.string().required('نام کاربری را وارد کنید'),
  password: yup
    .string()
    .required('رمز عبور را وارد کنید')
    .min(4, 'رمز عبور حداقل 4 کاراکتر می باشد'),
  // server: yup.string().required('سرور را انتخاب کنید'),
});

const defaultValues = {
  identifier: '',
  password: '',
};

function SignInPage() {
  const dispatch = useDispatch();
  const { control, formState, handleSubmit, setError, setValue, watch } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });

  const server = watch('server');

  useEffect(() => {
    setValue('identifier', '09128355518', {
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue('password', 'qwaszx@@11', {
      shouldDirty: true,
      shouldValidate: true,
    });
  }, [setValue]);

  useEffect(() => {
    sessionStorage.setItem('server', server);
    axios.defaults.baseURL = server;
  }, [server]);

  const [isLoading, setIsLoading] = useState(false);

  const { isValid, dirtyFields, errors } = formState;

  function onSubmit({ identifier, password }) {
    setIsLoading(true);
    jwtService
      .signInWithUsernameAndPassword(identifier, password)
      .then((user) => {
        setIsLoading(false);
        // No need to do anything, user data will be set at app/auth/AuthContext
      })
      .catch((_errors) => {
        setIsLoading(false);
        dispatch(showMessage({ message: 'رمز عبور یا نام کاربری اشتباه است', variant: 'error' }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <div className="flex flex-col items-center flex-1 min-w-0 sm:flex-row md:items-start sm:justify-center md:justify-start">
      <Paper className="w-full h-full px-16 py-8 sm:h-auto md:flex md:items-center md:justify-end sm:w-auto md:h-full md:w-2/5 sm:p-48 md:p-64 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none">
        <div className="w-full mx-auto max-w-512 sm:w-full sm:mx-16">
          {/* <img className="w-48 mx-auto" src="assets/images/logo/logo.svg" alt="logo" /> */}

          <Typography className="mb-32 text-xl font-extrabold leading-tight tracking-tight text-center">
            پنل پشتیبان حامی پیک
          </Typography>

          <Paper className="p-40 shadow-6">
            <Typography className="text-center">ورود</Typography>
            <Grid
              container
              rowSpacing={3}
              component="form"
              name="loginForm"
              noValidate
              className="flex flex-col justify-center w-full mt-32"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Grid item xs={12}>
                <CustomTextField control={control} name="identifier" label="نام کاربری" autoFocus />
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  control={control}
                  name="password"
                  label="رمز عبور"
                  type="password"
                />
              </Grid>
              <Grid item xs={12}>
                <LoadingButton
                  loading={isLoading}
                  variant="contained"
                  color="primary"
                  className="w-full mt-16 "
                  aria-label="Sign in"
                  // disabled={_.isEmpty(dirtyFields) || !isValid}
                  type="submit"
                  size="large"
                >
                  ورود
                </LoadingButton>
              </Grid>
              <Grid item xs={12}>
                <Button color="primary">فراموشی رمز عبور</Button>
              </Grid>
              <Grid item xs={12}>
                <Link to="/sign-up">ثبت نام</Link>
              </Grid>
            </Grid>
          </Paper>
        </div>
      </Paper>

      <Box
        className="relative items-start justify-start flex-auto hidden h-full overflow-hidden md:flex"
        sx={{
          background: 'url(/assets/images/vector/login-background.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: 'background.paper',
        }}
      >
        <img className="mt-128 mr-160 w-200" src="assets/images/logo/logo.svg" alt="logo" />
      </Box>
    </div>
  );
}

export default SignInPage;
